<template>
  <div class="global-search-card">
    <span class="card-title">{{ $t('GlobalSearch') }}</span>
    <div class="global-search-container">
      <div
        v-for="field in fields"
        class="card-info-item-container"
        :key="field.label"
        :style="[{ width: '100%', overflow: 'visible' }]"
      >
        <div class="card-info-item">
          <input-field
            :key="field.varName"
            :input-type="field.inputType"
            :value="field.value"
            :label="field.label"
            :input-disabled="field.disabled"
            :select-options-list="field.options"
            :disableBranchNodes="field.disableBranchNodes"
            :checkbox-options="field.checkboxOptions"
            :min="field.min"
            :max="field.max"
            :step="field.step"
            :size="'large'"
            :clearable="field.clearable"
            :required="field.required"
            :inputFieldContainerStyling="{ 'padding': '0' }"
            :radio-options="field.radioOptions"
            :placeholder="field.placeholder"
            :input-style="inputStyle"
            @input="updateField($event, field)"
          />
        </div>
      </div>
    </div>
    <div class="action-buttons">
      <custom-button
        :label="$t('Submit')"
        :button-color="'#29BDF0'"
        :label-color="'#FFF'"
        :button-styling="actionButtonsStylingSave"
        :disabled="!requiredFieldsFilled"
        @buttonClick="search"
      />
    </div>
    <loading-spinner
      :active.sync="loading"
      :is-full-page="true"
      color="#29BDF0"
    />
  </div>
</template>

<script>
import CustomButton from '@/newComponents/_Atoms/CustomButton';
import InputField from "@/newComponents/_Atoms/InputField.vue";
import LoadingSpinner from "vue-loading-overlay";
import { mapActions } from 'vuex';
import { bus } from '@/main.js';

export default {
  name: "GlobalSearchForm",

  components: {
    CustomButton,
    InputField,
    LoadingSpinner,
  },

  data() {
    return {
      loading: false,
      actionButtonsStyling: {
        'border': '1px solid #29BDF0',
        'border-radius': '7px',
        'font-size': '10px',
        'line-height': '12px',
        'height': '20px',
        'font-weight': '600'
      },
      actionButtonsStylingSave: {
        'font-size': '10px',
        'line-height': '12px',
        'height': '20px',
        'font-weight': '600',
        'border-radius': '4px',
      },

      inputStyle: {
        'border-radius': '4.1px',
        'border-color': 'rgb(219, 219, 224)'
      },

      globalSearch: {
        layer: null,
        attribute: null,
        value: null,
      },

      layers: [
        {
          layer: 'fc_building',
          hasExtraFormDataField: false,
          labelField: 'bd_demand_point_address',
          geoJSONField: 'technicalsite.node.nd_geo_json',
          objectListName: 'buildings',
        },
        {
          layer: 'fc_pathway',
          hasExtraFormDataField: false,
          geoJSONField: 'pw_geo_json',
          objectListName: 'pathways',
        },
        {
          layer: 'fc_pole',
          hasExtraFormDataField: true,
          extraFormDataFieldValue: 'poles',
          geoJSONField: 'node.nd_geo_json',
          objectListName: 'technical_points',
        },
        {
          layer: 'fc_manhole',
          hasExtraFormDataField: true,
          extraFormDataFieldValue: 'manholes',
          geoJSONField: 'node.nd_geo_json',
          objectListName: 'technical_points',
        },
        {
          layer: 'fc_cabinet',
          hasExtraFormDataField: true,
          extraFormDataFieldValue: 'cabinets',
          geoJSONField: 'node.nd_geo_json',
          objectListName: 'technical_points',
        },
        {
          layer: 'fc_closure',
          hasExtraFormDataField: false,
          geoJSONField: 'technicalpoint.node.nd_geo_json',
          objectListName: 'closures',
        },
        {
          layer: 'fc_closure_zone',
          hasExtraFormDataField: false,
          geoJSONField: 'clz_geo_json',
          objectListName: 'closures_zones',
        },
        {
          layer: 'fc_fiber_distribution_point',
          hasExtraFormDataField: true,
          extraFormDataFieldValue: 'fdc',
          geoJSONField: 'node.nd_geo_json',
          objectListName: 'technical_sites',
        },
        {
          layer: 'fc_fdp_zone',
          hasExtraFormDataField: false,
          geoJSONField: 'fdpz_geo_json',
          objectListName: 'fiber_distribution_points',
        },
        {
          layer: 'fc_optical_line_termination',
          hasExtraFormDataField: true,
          extraFormDataFieldValue: 'olt',
          geoJSONField: 'node.nd_geo_json',
          objectListName: 'technical_sites',
        },
        {
          layer: 'fc_olt_zone',
          hasExtraFormDataField: false,
          geoJSONField: 'oltz_geo_json',
          objectListName: 'optical_line_terminations',
        },
        {
          layer: 'fc_annotation_point',
          hasExtraFormDataField: false,
          geoJSONField: 'anp_geo_json',
          objectListName: 'annotation_points',
        },
        {
          layer: 'fc_annotation_zone',
          hasExtraFormDataField: false,
          geoJSONField: 'anz_geo_json',
          objectListName: 'annotation_zones',
        },
        {
          layer: 'fc_cartography',
          hasExtraFormDataField: false,
          geoJSONField: 'ctg_geo_json',
          objectListName: 'cartographies',
        },
        {
          layer: 'fc_cable',
          hasExtraFormDataField: true,
          geoJSONField: 'cb_geo_json',
          objectListName: 'cables',
        },
        {
          layer: 'fc_technical_local_mdu',
          hasExtraFormDataField: true,
          geoJSONField: 'technicalSite.node.nd_geo_json',
          objectListName: 'technical_locals_mdu',
        },
        {
          layer: 'fc_technical_local_fdp',
          hasExtraFormDataField: true,
          geoJSONField: 'technicalSite.node.nd_geo_json',
          objectListName: 'technical_locals_fdp',
        },
        {
          layer: 'fc_technical_local_olt',
          hasExtraFormDataField: true,
          geoJSONField: 'technicalSite.node.nd_geo_json',
          objectListName: 'technical_locals_olt',
        },
        {
          layer: 'fc_technical_local_site',
          hasExtraFormDataField: true,
          geoJSONField: 'technicalSite.node.nd_geo_json',
          objectListName: 'technical_locals_site',
        },
        {
          layer: 'fc_toby_box',
          hasExtraFormDataField: true,
          geoJSONField: 'node.nd_geo_json',
          objectListName: 'toby_boxes',
        },
      ],
      layerOptions: [],
      attributeOptions: [],

      loading: false,
    }
  },

  created() {
    this.getLayersInfo();
  },

  computed: {
    fields() {
      return [
        {
          icon: "",
          label: this.$i18n.tc("Layer", 1),
          value: this.globalSearch.layer,
          varName: 'layer',
          inputType: 'select',
          required: true,
          options: this.layerOptions,
          placeholder: "",
          clearable: true,
        },
        {
          icon: "",
          label: this.$i18n.tc("Attribute", 1),
          value: this.globalSearch.attribute,
          varName: 'attribute',
          inputType: 'select',
          required: true,
          options: this.attributeOptions,
          placeholder: "",
          clearable: true,
          disableBranchNodes: true,
        },
        {
          icon: "",
          label: this.$i18n.tc("Value", 1),
          value: this.globalSearch.value,
          varName: 'value',
          inputType: 'text',
          required: true,
        },
      ];
    },

    requiredFieldsFilled() {
      return !!this.globalSearch.layer && !!this.globalSearch.attribute && !!this.globalSearch.value;
    }
  },

  watch: {
    "globalSearch.layer"() {
      this.updateField(null, { varName: 'attribute' });
      this.requestLayerAtributes();
    },
  },

  methods: {
    ...mapActions([
      'FETCH_ALL_OBJECTS_PROPERTIES_WITHOUT_FIELDS',
      'GET_LAYER_ATTRIBUTES',
    ]),

    updateField: _.debounce(function (event, field) {
      this.globalSearch[field.varName] = event;
    }, 50),

    async getLayersInfo() {
      try {
        let objectProperties = this.$store.getters.getAllObjectTypesProperties
        if (objectProperties.length === 0) {
          await this.FETCH_ALL_OBJECTS_PROPERTIES_WITHOUT_FIELDS()
        }
        this.updateLayersInfo()
      } catch (error) {
        console.log(error)
      }
    },

    updateLayersInfo() {
      this.layers.forEach((layer) => {

        layer.endpoint = this.$store.getters.getLayerEndpoint(layer.layer)
        layer.permissionName = this.$store.getters.getLayerPermissionName(
          layer.layer,
        )
        layer.label = this.getLayerName(layer.layer)
        layer.initials = this.$store.getters.getLayerInitials(layer.layer)
        layer.idField = layer.initials + '_id'
        layer.uuidField = layer.initials + '_uuid'
        if (!layer.hasOwnProperty('labelField')) {
          layer.labelField = layer.initials + '_label'
        }
        layer.creationDateField = layer.initials + '_created_at'
        layer.updateDateField = layer.initials + '_updated_at'
      })
      let arr = []
      let numberOfPossibleLayers = this.layers.length
      for (let i = 0; i < numberOfPossibleLayers; i++) {
        let layer = this.layers[i]
        arr.push({
          id: layer.layer,
          label: layer.label,
        })
      }
        this.layerOptions = [...arr]
    },

    /**
     * Get's the name to exhibit on the layer option label.
     * @param {String} layer - layer being analysed
     * @returns {String}
     */
    getLayerName(layer) {
      let label = this.$store.getters.getLayerTranslationKey(layer)
      return this.$i18n.tc(label, 2)
    },

    /**
     * Assigns fetched result into an object array with id and label to be used in computed property for tree select.
     */
    async requestLayerAtributes() {
      try {
        this.loading = true;
        let attributes = []
        let extra_fields = []
        let custom_fields = []
        if (this.globalSearch.layer) {
          let atributeList = await this.GET_LAYER_ATTRIBUTES({
            layer: this.globalSearch.layer,
          })
          atributeList.attributes.forEach((item) => {
            attributes.push({
              id: 'attributes:' + item,
              label: this.formatText(item),
            })
          })
          atributeList.custom_fields.forEach((item) => {
            custom_fields.push({
              id: 'custom_fields:' + item.label,
              label: item.label,
            })
          })
          atributeList.extra_fields.forEach((item) => {
            extra_fields.push({
              id: 'extra_fields:' + item,
              label: this.formatText(item),
            })
          })

          this.populateAttributeOptionsArray(attributes, extra_fields, custom_fields);
        }
      } catch (err) {
        console.log(err)
      } finally {
        this.loading = false;
      }
    },

    /**
     * @param {String} item - attributes unformated label
     * @returns {String} - Formated Label with capital letters
     */
    formatText(item) {
      let label = item
      if (item.includes('_')) {
        label = label.substring(label.indexOf('_') + 1).replace(/_/g, ' ')
      }
      label = label.split(' ')
      for (let i = 0; i < label.length; i++) {
        label[i] = label[i].charAt(0).toUpperCase() + label[i].slice(1)
      }
      return label.join(' ')
    },

    populateAttributeOptionsArray(attributes, extra_fields, custom_fields) {
      this.attributeOptions = [];
      if (attributes && attributes.length > 0) {
        this.attributeOptions.push({
          id: 'attributes',
          label: this.$i18n.tc('Attributes',1),
          children: attributes,
        })
      }
      if (custom_fields && custom_fields.length > 0) {
        this.attributeOptions.push({
          id: 'custom_fields',
          label: this.$i18n.tc('CustomFields',1),
          children: custom_fields,
        })
      }
      if (extra_fields && extra_fields.length > 0) {
        this.attributeOptions.push({
          id: 'extra_fields',
          label: this.$i18n.tc('ExtraFields',1),
          children: extra_fields,
        })
      }
    },

    search() {
      bus.$emit('execute-global-search', this.globalSearch)
    },
  }
}
</script>

<style scoped>
.global-search-card {
  height: 100%;
  max-height: 100%;
  background-color: #fff;
  position: relative;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
}

.card-title {
  color: #767676;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
  line-height: 20px;
  text-transform: uppercase;
  margin-bottom: 16px;
}

.action-buttons {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-end;
  position: absolute;
  right: 16px;
  bottom: 18px;
}

.global-search-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>



// WEBPACK FOOTER //
// src/newComponents/WorkspacesManagement/GlobalSearch/GlobalSearchForm.vue